import { render, staticRenderFns } from "./TagComboBox.vue?vue&type=template&id=f09425a8&scoped=true"
import script from "./TagComboBox.vue?vue&type=script&lang=js"
export * from "./TagComboBox.vue?vue&type=script&lang=js"
import style0 from "./TagComboBox.vue?vue&type=style&index=0&id=f09425a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f09425a8",
  null
  
)

export default component.exports